import NavBar from "./Layouts/NavBar";
import CeritaUMKM from "./Components/CeritaUMKM";
import "bootstrap/dist/css/bootstrap.min.css";
import Lecturer from "./Components/Lecturer";
import FooterWeb from "./Layouts/FooterWeb";
//Import menggunakan Index yang dibuat di dalam folder
import {
  Header,
  KelasKami,
  Home,
  PemilihanKelas,
  NavBarBLogin,
} from "./Components/ComponentIndex";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Registration from "./Components/Registration";
import OurPartner from "./Components/OurPartner";
import PelatihanDaring from "./Components/PelatihanDaring";
import TatapMuka from "./Components/TatapMuka";
import Editprofile from "./Components/EditProfile";
import ProfilePage from "./Components/ProfilePage";
import Katalog from "./Components/Katalog";

import KatalogUMKM from "./Components/KatalogUMKM";
import UMKMDetails from "./Components/UMKMDetails";
import DetailsCerita from "./Components/DetailsCerita";
import ListDetailsCerita from "./Components/ListDetailsCerita";
import DetailsSpeaker from "./Components/DetailsSpeaker";
import PelatihanDetails from "./Components/PelatihanDetails";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Route buat nyoba mockAPI */}
          <Route
            path="/mockAPI"
            element={
              <>
                <NavBar />
              </>
            }
          ></Route>
          {/* Route buat nyoba mockAPI */}

          <Route
            path="/"
            element={
              <>
                {" "}
                <NavBarBLogin />
                <Header />
                <Home />
                <KelasKami />
                <Lecturer />
                <CeritaUMKM />
                <OurPartner />
              </>
            }
          ></Route>
          <Route
            path="/Home"
            element={
              <>
                {" "}
                <NavBar />
                <Header />
                <Home />
                <KelasKami />
                <Lecturer />
                <CeritaUMKM />
                <OurPartner />
              </>
            }
          ></Route>
          <Route
            path="/Daftar"
            element={
              <>
                <NavBar />
                <Registration />
              </>
            }
          ></Route>
          <Route
            path="/PelatihanDaring"
            element={
              <>
                <NavBar />
                <PelatihanDaring />
              </>
            }
          ></Route>
          <Route
            path="/PelatihanTatapMuka"
            element={
              <>
                <NavBar />
                <TatapMuka />
              </>
            }
          ></Route>
          <Route
            path="/DigitalMarketing"
            element={
              <>
                <NavBar />
                <PelatihanDetails />
              </>
            }
          ></Route>
          <Route
            path="/Kelas"
            element={
              <>
                <NavBar />
                <PemilihanKelas />
              </>
            }
          />
          <Route
            path="/EditProfilePage"
            element={
              <>
                <NavBar />
                <Editprofile />
              </>
            }
          ></Route>
          <Route
            path="/ProfilePage"
            element={
              <>
                <NavBar />
                <ProfilePage />
              </>
            }
          ></Route>
          <Route
            path="/Katalog"
            element={
              <>
                <NavBar />
                <Katalog />
              </>
            }
          ></Route>

          <Route
            path="/KatalogUMKM"
            element={
              <>
                <NavBar />
                <KatalogUMKM />
              </>
            }
          ></Route>

          <Route
            path="/Katalog/UMKMDetails"
            element={
              <>
                <NavBar />
                <UMKMDetails />
              </>
            }
          ></Route>

          <Route
            path="/CeritaUMKM"
            element={
              <>
                <NavBar />
                <ListDetailsCerita />
              </>
            }
          ></Route>

          <Route
            path="/CeritaUMKM/details"
            element={
              <>
                <NavBar />
                <DetailsCerita />
              </>
            }
          ></Route>

          <Route
            path="/Pembicara"
            element={
              <>
                <NavBar />
                <DetailsSpeaker />
              </>
            }
          ></Route>
        </Routes>
        <FooterWeb />
      </BrowserRouter>
    </div>
  );
}

export default App;
